import { ArrowConnector } from '../../../components/admin/BiddingItemStatusUpdate/BiddingItemStatusUpdateArrow';
import { Check } from 'lucide-react';

interface StepRowProps {
  label: string;
  count: number;
  buttonLabel?: string;
  onAction?: () => void;
  badgeColor: string;
  icon: React.ReactNode;
  isLastStep?: boolean;
  hasRole: boolean;
}

// 各行を表示するコンポーネント
export const StepRow: React.FC<StepRowProps> = ({ 
  label, 
  count, 
  buttonLabel, 
  onAction, 
  badgeColor,
  icon,
  isLastStep = false,
  hasRole = false
}) => {

  return (
    <div className="flex flex-col sm:flex-col w-full gap-4 p-2 rounded-lg hover:bg-slate-50 transition-colors duration-200 border border-transparent hover:border-slate-100">
      
      <div className='flex flex-row items-center'>
        {/* 左側: アイコンとラベル [ラベル] */}
        <div className="flex items-center gap-3 w-auto sm:w-40 justify-start sm:ml-5">
          <div className={`flex items-center justify-center w-10 h-10 rounded-full bg-white shadow-sm border border-slate-100`}>
            {icon}
          </div>
          <span className={`px-4 py-1.5 rounded-md font-bold text-sm border shadow-sm w-24 text-center tracking-widest ${badgeColor}`}>
            {label}
          </span>
        </div>

        {/* 中央: 件数 */}
        <div className="flex-auto w-20 sm:w-auto max-w-40 text-center text-xl font-mono font-medium text-lg text-slate-700 place-self-center">
          {count} <span className="text-base text-slate-400 font-sans">件</span>
        </div>
      </div>

      <div className='sm:w-100 flex flex-row items-center place-content-start pl-21 sm:pl-25 gap-5'>
        {/* 矢印 */}
        {!isLastStep && <ArrowConnector />}

        {/* 右側: アクションボタン 「ボタン」 */}
        <div className="w-33 sm:w-31 flex justify-center sm:justify-end">
          {!isLastStep && buttonLabel && (
            <button
              onClick={onAction}
              disabled={count === 0 || !hasRole}
              
              className={`
                w-50 sm:w-60 py-2 rounded-lg text-sm font-bold shadow-sm transition-all
                flex items-center justify-center gap-2
                ${!hasRole 
                  ? 'hidden bg-slate-100 text-slate-400 cursor-not-allowed shadow-none border border-slate-200' 
                  : count > 0 
                    ? 'bg-blue-600 text-white hover:bg-blue-700 hover:shadow-lg hover:-translate-y-0.5 active:translate-y-0 active:shadow-sm' 
                    : 'bg-slate-200 text-slate-400 cursor-not-allowed shadow-none'}
              `}
            >
              <Check className="w-4 h-4" />
              {buttonLabel}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};